import { render, staticRenderFns } from "./CompareContainer.vue?vue&type=template&id=9a9f2c74&"
import script from "./CompareContainer.vue?vue&type=script&lang=js&"
export * from "./CompareContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports